<template>
  <page>
    <form>
                <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Date Range</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
             <v-card>
        <v-card-text>
                      <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <cal-picker v-model="form.fromDate" :label="labels.fromDate" v-validate="'required|start_after_today'" :data-vv-as="labels.fromDate" data-vv-name="fromDate" :error-messages="errors.collect('fromDate')" :max="new Date()"></cal-picker>
                </v-flex>
                <v-flex xs12 md6>
                  <cal-picker v-model="form.toDate" :label="labels.toDate" v-validate="toDateValidation" :data-vv-as="labels.toDate" data-vv-name="toDate" :error-messages="errors.collect('toDate')" :min="this.form.fromDate" :max="new Date()"></cal-picker>
                </v-flex>
              </v-layout>
              </v-container>
        </v-card-text>
      </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
                <v-spacer class="mt-2"></v-spacer>
                <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Selection Criteria</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
      <v-card>
        <v-card-text>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-radio-group v-model="form.rptType" :mandatory="true" class="ml-3 pa-0">
                  <v-radio :label="labels.uobBank" value="1"></v-radio>
                  <v-radio :label="labels.uia" value="2"></v-radio>
                  <v-radio :label="labels.a40" value="3"></v-radio>
                  <v-radio :label="labels.others" value="4"></v-radio>
                  <v-radio :label="labels.ri" value="5"></v-radio>
                </v-radio-group>
              </v-layout>
            </v-container>
        </v-card-text>
      </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-flex lg6 xs12>
        <v-checkbox dense v-model="form.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
      </v-flex>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex  xs12 class="pt-3">
            <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
            </v-btn>
            <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-container>
    </form>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import clone from 'clone'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import { extractMenu } from '@/utils/extract'

export default {
  data() {
    return {
      labels: {
        fromDate: 'Transaction Date From*',
        toDate: 'Transaction Date To*',
        rptType: 'Report Type',
        uobBank: 'UOB Bank',
        uia: 'UIA',
        a40: 'A40',
        others: 'Others',
        ri: 'RI',
        export: 'Export to',
        printRptRunTime: 'Print Runtime Parameters'
      },
      form: {
        fromDate: '',
        toDate: '',
        rptType: 1,
        printRptRunTime: true
      },
      polTypeList: [],
      billAcctList: [],
      menu: {},
      submitting: false,
      panel: [0],
      panel1: [0]
    }
  },
  created() {
    this.$validator.extend('start_after_today', {
      getMessage(field, args) {
        return `The ${field} cannot be later than the date of application.`
      },
      validate(value, args) {
        if (value) {
          const today = removeTime(new Date())
          const tomorrow = new Date(today)
          tomorrow.setDate(tomorrow.getDate() + 1)
          const startDate = removeTime(value)
          // if (isAfter(today, startDate)) return false
          // else return true
          return (isAfter(tomorrow, startDate))
        } else return true
      }
    })
    this.doInit()
  },
  methods: {
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          let clonedForm = clone(this.form)
          await this.$http.post(apiURI, clonedForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doInit() {
      this.setMenu()
    },
    async setMenu() {
      try {
        if (this.$store.state.reports.custom1Reports.init !== 1) {
          await this.$store.dispatch('custom1ReportsInit')
        }
        const apiURI = this.rptMenu.crossSelling
        const result = await this.$http.get(apiURI)
        if (result.data) {
          this.menu = extractMenu(result.data._links)
          // this.getPolTypeList()
        }
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.custom1Reports.menu
    },
    supportedList() {
      const result = []
      // result.push(reportFormat.PDF)
      result.push(reportFormat.XLSX)
      return result
    },
    toDateValidation() {
      const result = 'required|start_after_today|from_to_date:' + this.form.fromDate
      return result
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
  }
}
</script>
